import React, { useEffect, useState } from "react";
import { fetchUserProfile } from "../../services/newUserService";
import { handleErrors } from "../../utils/errorHandler";

export const DashboardIntro = () => {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await fetchUserProfile();
        setUserName(userData.data.result.userName);
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchUserData();
  }, []);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  if (!userName) return null;

  return (
    <div className="row mb-3 pb-1">
      <div className="col-12">
        <div className="d-flex align-items-lg-center flex-lg-row flex-column">
          <div className="flex-grow-1">
            <h4 className="mb-1 dashboard-greeting">
              {getGreeting()}, {userName}
            </h4>
            <p className="mb-0 dashboard-greeting-text">
              Here&apos;s what&apos;s happening with contacts, applications, and jobs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
